const headers = {
  name: "Lpo Order",
  navigate: {
    path: [
      {
        name: "Orders",
        path: "/app/lpo",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
